export async function openFileInBrowser(fileData, fileType) {
  try {
    /* Convert to Uint8Array */
    const bytes = new Uint8Array(
      atob(fileData)
        .split('')
        .map((char) => char.charCodeAt(0)),
    )
    /* Create Blob */
    const blob = new Blob([bytes], { type: fileType })
    /* Create File Url */
    const url = URL.createObjectURL(blob)
    /* Open File in New Browser Tab */
    window.open(url, '_blank')
    return Promise.resolve()
  } catch (exception) {
    return Promise.reject(exception)
  }
}
